export default __webpack_public_path__ + "static/media/illustration-1.32d0dbcf.svg";